export default "__VITE_ASSET__DF7WB2BA__"